// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Next = require("../../reason/next/Next.bs.js");
let Alert = require("../common/Components/Alert.bs.js");
let React = require("react");
let Redirect = require("../../reason/common/Redirect.bs.js");
let ButtonsV5 = require("../common/Components/ButtonsV5.bs.js");
let Formality = require("@tan/formality/src/Formality.bs.js");
let Form__Label = require("../common/Components/Form__Label.bs.js");
let FormalityUI = require("../common/Components/FormalityUI.bs.js");
let AvatarSrcUrl = require("../../utils/AvatarSrcUrl.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Stdlib_Result = require("@rescript/runtime/lib/js/Stdlib_Result.js");
let Form__TextInput = require("../common/Components/Form__TextInput.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let RichTextEditorV5 = require("../common/Components/RichTextEditorV5.bs.js");
let ProfilePhotoInput = require("../common/Components/ProfilePhotoInput.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let UnifiedProfileSave = require("./UnifiedProfileSave.bs.js");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let Formality__ReactUpdate = require("@tan/formality/src/Formality__ReactUpdate.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let UnifiedProfileSettingsUI = require("./UnifiedProfileSettingsUI.bs.js");
let UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let UnifiedProfileSocialValidation = require("./UnifiedProfileSocialValidation.bs.js");
let UnifiedAddDisplayOnlyMemberQuery_graphql = require("../../__generated__/UnifiedAddDisplayOnlyMemberQuery_graphql.bs.js");
let UnifiedAddDisplayOnlyMemberAddDisplayMemberMutation_graphql = require("../../__generated__/UnifiedAddDisplayOnlyMemberAddDisplayMemberMutation_graphql.bs.js");

let convertVariables = UnifiedAddDisplayOnlyMemberAddDisplayMemberMutation_graphql.Internal.convertVariables;

let convertResponse = UnifiedAddDisplayOnlyMemberAddDisplayMemberMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = UnifiedAddDisplayOnlyMemberAddDisplayMemberMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, UnifiedAddDisplayOnlyMemberAddDisplayMemberMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use = RescriptRelay_Mutation.useMutation(convertVariables, UnifiedAddDisplayOnlyMemberAddDisplayMemberMutation_graphql.node, convertResponse, convertWrapRawResponse);

let AddDisplayMemberMutation_imageContentType_decode = UnifiedAddDisplayOnlyMemberAddDisplayMemberMutation_graphql.Utils.imageContentType_decode;

let AddDisplayMemberMutation_imageContentType_fromString = UnifiedAddDisplayOnlyMemberAddDisplayMemberMutation_graphql.Utils.imageContentType_fromString;

let AddDisplayMemberMutation = {
  imageContentType_decode: AddDisplayMemberMutation_imageContentType_decode,
  imageContentType_fromString: AddDisplayMemberMutation_imageContentType_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

function useAddDisplayMember() {
  let match = use();
  let commit = match[0];
  return UnifiedProfileSave.useAccountSave(match[1], (input, onCompleted, onError) => commit({
    input: input
  }, undefined, undefined, undefined, onCompleted, onError, undefined), response => {
    let match = response.addUnifiedDisplayMember;
    if (match === undefined) {
      return {
        TAG: "Error",
        _0: "The profile could not be saved. Please try again."
      };
    }
    switch (match.__typename) {
      case "UpdateUnifiedAccountProfilePayload" :
        return {
          TAG: "Ok",
          _0: undefined
        };
      case "__unselected" :
        return {
          TAG: "Error",
          _0: "The profile could not be saved. Please try again."
        };
      default:
        return {
          TAG: "Error",
          _0: match.message
        };
    }
  });
}

let validators_linkedIn = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: param => Stdlib_Result.mapError(UnifiedProfileSocialValidation.linkedIn(param.linkedIn), message => ({
    NAME: "InvalidLinkedIn",
    VAL: message
  }))
};

let validators_title = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: param => {
    let title = param.title;
    if (title === "") {
      return {
        TAG: "Error",
        _0: "IsRequired"
      };
    } else {
      return {
        TAG: "Ok",
        _0: title
      };
    }
  }
};

let validators_lastName = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: param => {
    let lastName = param.lastName;
    if (lastName === "") {
      return {
        TAG: "Error",
        _0: "IsRequired"
      };
    } else {
      return {
        TAG: "Ok",
        _0: lastName
      };
    }
  }
};

let validators_firstName = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: param => {
    let firstName = param.firstName;
    if (firstName === "") {
      return {
        TAG: "Error",
        _0: "IsRequired"
      };
    } else {
      return {
        TAG: "Ok",
        _0: firstName
      };
    }
  }
};

let validators = {
  yelp: undefined,
  tikTok: undefined,
  youTube: undefined,
  linkedIn: validators_linkedIn,
  instagram: undefined,
  facebook: undefined,
  twitter: undefined,
  bio: undefined,
  headshot: undefined,
  licenseNumber: undefined,
  title: validators_title,
  lastName: validators_lastName,
  firstName: validators_firstName
};

function initialFieldsStatuses(input) {
  return {
    yelp: "Pristine",
    tikTok: "Pristine",
    youTube: "Pristine",
    linkedIn: "Pristine",
    instagram: "Pristine",
    facebook: "Pristine",
    twitter: "Pristine",
    bio: "Pristine",
    headshot: "Pristine",
    licenseNumber: "Pristine",
    title: "Pristine",
    lastName: "Pristine",
    firstName: "Pristine"
  };
}

let initialFieldStatuses_xxx = initialFieldsStatuses;

function initialState(input) {
  return {
    input: input,
    fieldsStatuses: initialFieldsStatuses(input),
    collectionsStatuses: undefined,
    formStatus: "Editing",
    submissionStatus: "NeverSubmitted"
  };
}

function validateForm(input, validators, fieldsStatuses) {
  let match_0 = {
    TAG: "Ok",
    _0: input.yelp
  };
  let match_0$1 = {
    TAG: "Ok",
    _0: input.tikTok
  };
  let match_0$2 = {
    TAG: "Ok",
    _0: input.youTube
  };
  let match = fieldsStatuses.linkedIn;
  let tmp;
  tmp = typeof match !== "object" ? validators.linkedIn.validate(input) : match._0;
  let match_0$3 = {
    TAG: "Ok",
    _0: input.instagram
  };
  let match_0$4 = {
    TAG: "Ok",
    _0: input.facebook
  };
  let match_0$5 = {
    TAG: "Ok",
    _0: input.twitter
  };
  let match_0$6 = {
    TAG: "Ok",
    _0: input.bio
  };
  let match_0$7 = {
    TAG: "Ok",
    _0: input.headshot
  };
  let match_0$8 = {
    TAG: "Ok",
    _0: input.licenseNumber
  };
  let match$1 = fieldsStatuses.title;
  let tmp$1;
  tmp$1 = typeof match$1 !== "object" ? validators.title.validate(input) : match$1._0;
  let match$2 = fieldsStatuses.lastName;
  let tmp$2;
  tmp$2 = typeof match$2 !== "object" ? validators.lastName.validate(input) : match$2._0;
  let match$3 = fieldsStatuses.firstName;
  let tmp$3;
  tmp$3 = typeof match$3 !== "object" ? validators.firstName.validate(input) : match$3._0;
  let yelpResult = match_0;
  let yelpResult$1;
  if (yelpResult.TAG === "Ok") {
    let tikTokResult = match_0$1;
    if (tikTokResult.TAG === "Ok") {
      let youTubeResult = match_0$2;
      if (youTubeResult.TAG === "Ok") {
        let linkedInResult = tmp;
        if (linkedInResult.TAG === "Ok") {
          let instagramResult = match_0$3;
          if (instagramResult.TAG === "Ok") {
            let facebookResult = match_0$4;
            if (facebookResult.TAG === "Ok") {
              let twitterResult = match_0$5;
              if (twitterResult.TAG === "Ok") {
                let bioResult = match_0$6;
                if (bioResult.TAG === "Ok") {
                  let headshotResult = match_0$7;
                  if (headshotResult.TAG === "Ok") {
                    let licenseNumberResult = match_0$8;
                    if (licenseNumberResult.TAG === "Ok") {
                      let titleResult = tmp$1;
                      if (titleResult.TAG === "Ok") {
                        let lastNameResult = tmp$2;
                        if (lastNameResult.TAG === "Ok") {
                          let firstNameResult = tmp$3;
                          if (firstNameResult.TAG === "Ok") {
                            return {
                              TAG: "Valid",
                              output: {
                                firstName: firstNameResult._0,
                                lastName: lastNameResult._0,
                                title: titleResult._0,
                                licenseNumber: licenseNumberResult._0,
                                headshot: headshotResult._0,
                                bio: bioResult._0,
                                twitter: twitterResult._0,
                                facebook: facebookResult._0,
                                instagram: instagramResult._0,
                                linkedIn: linkedInResult._0,
                                youTube: youTubeResult._0,
                                tikTok: tikTokResult._0,
                                yelp: yelpResult._0
                              },
                              fieldsStatuses: {
                                yelp: {
                                  TAG: "Dirty",
                                  _0: yelpResult,
                                  _1: "Hidden"
                                },
                                tikTok: {
                                  TAG: "Dirty",
                                  _0: tikTokResult,
                                  _1: "Hidden"
                                },
                                youTube: {
                                  TAG: "Dirty",
                                  _0: youTubeResult,
                                  _1: "Hidden"
                                },
                                linkedIn: {
                                  TAG: "Dirty",
                                  _0: linkedInResult,
                                  _1: "Shown"
                                },
                                instagram: {
                                  TAG: "Dirty",
                                  _0: instagramResult,
                                  _1: "Hidden"
                                },
                                facebook: {
                                  TAG: "Dirty",
                                  _0: facebookResult,
                                  _1: "Hidden"
                                },
                                twitter: {
                                  TAG: "Dirty",
                                  _0: twitterResult,
                                  _1: "Hidden"
                                },
                                bio: {
                                  TAG: "Dirty",
                                  _0: bioResult,
                                  _1: "Hidden"
                                },
                                headshot: {
                                  TAG: "Dirty",
                                  _0: headshotResult,
                                  _1: "Hidden"
                                },
                                licenseNumber: {
                                  TAG: "Dirty",
                                  _0: licenseNumberResult,
                                  _1: "Hidden"
                                },
                                title: {
                                  TAG: "Dirty",
                                  _0: titleResult,
                                  _1: "Shown"
                                },
                                lastName: {
                                  TAG: "Dirty",
                                  _0: lastNameResult,
                                  _1: "Shown"
                                },
                                firstName: {
                                  TAG: "Dirty",
                                  _0: firstNameResult,
                                  _1: "Shown"
                                }
                              },
                              collectionsStatuses: undefined
                            };
                          }
                          yelpResult$1 = yelpResult;
                        } else {
                          yelpResult$1 = yelpResult;
                        }
                      } else {
                        yelpResult$1 = yelpResult;
                      }
                    } else {
                      yelpResult$1 = yelpResult;
                    }
                  } else {
                    yelpResult$1 = yelpResult;
                  }
                } else {
                  yelpResult$1 = yelpResult;
                }
              } else {
                yelpResult$1 = yelpResult;
              }
            } else {
              yelpResult$1 = yelpResult;
            }
          } else {
            yelpResult$1 = yelpResult;
          }
        } else {
          yelpResult$1 = yelpResult;
        }
      } else {
        yelpResult$1 = yelpResult;
      }
    } else {
      yelpResult$1 = yelpResult;
    }
  } else {
    yelpResult$1 = yelpResult;
  }
  return {
    TAG: "Invalid",
    fieldsStatuses: {
      yelp: {
        TAG: "Dirty",
        _0: yelpResult$1,
        _1: "Hidden"
      },
      tikTok: {
        TAG: "Dirty",
        _0: match_0$1,
        _1: "Hidden"
      },
      youTube: {
        TAG: "Dirty",
        _0: match_0$2,
        _1: "Hidden"
      },
      linkedIn: {
        TAG: "Dirty",
        _0: tmp,
        _1: "Shown"
      },
      instagram: {
        TAG: "Dirty",
        _0: match_0$3,
        _1: "Hidden"
      },
      facebook: {
        TAG: "Dirty",
        _0: match_0$4,
        _1: "Hidden"
      },
      twitter: {
        TAG: "Dirty",
        _0: match_0$5,
        _1: "Hidden"
      },
      bio: {
        TAG: "Dirty",
        _0: match_0$6,
        _1: "Hidden"
      },
      headshot: {
        TAG: "Dirty",
        _0: match_0$7,
        _1: "Hidden"
      },
      licenseNumber: {
        TAG: "Dirty",
        _0: match_0$8,
        _1: "Hidden"
      },
      title: {
        TAG: "Dirty",
        _0: tmp$1,
        _1: "Shown"
      },
      lastName: {
        TAG: "Dirty",
        _0: tmp$2,
        _1: "Shown"
      },
      firstName: {
        TAG: "Dirty",
        _0: tmp$3,
        _1: "Shown"
      }
    },
    collectionsStatuses: undefined
  };
}

function useForm(initialInput, onSubmit) {
  let memoizedInitialState = React.useMemo(() => initialState(initialInput), [initialInput]);
  let match = Formality__ReactUpdate.useReducer(memoizedInitialState, (state, action) => {
    if (typeof action !== "object") {
      switch (action) {
        case "BlurYelpField" :
          let result = Formality.validateFieldOnBlurWithoutValidator(state.input.yelp, state.fieldsStatuses.yelp, status => {
            let init = state.fieldsStatuses;
            return {
              yelp: status,
              tikTok: init.tikTok,
              youTube: init.youTube,
              linkedIn: init.linkedIn,
              instagram: init.instagram,
              facebook: init.facebook,
              twitter: init.twitter,
              bio: init.bio,
              headshot: init.headshot,
              licenseNumber: init.licenseNumber,
              title: init.title,
              lastName: init.lastName,
              firstName: init.firstName
            };
          });
          if (result !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurTikTokField" :
          let result$1 = Formality.validateFieldOnBlurWithoutValidator(state.input.tikTok, state.fieldsStatuses.tikTok, status => {
            let init = state.fieldsStatuses;
            return {
              yelp: init.yelp,
              tikTok: status,
              youTube: init.youTube,
              linkedIn: init.linkedIn,
              instagram: init.instagram,
              facebook: init.facebook,
              twitter: init.twitter,
              bio: init.bio,
              headshot: init.headshot,
              licenseNumber: init.licenseNumber,
              title: init.title,
              lastName: init.lastName,
              firstName: init.firstName
            };
          });
          if (result$1 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$1,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurYouTubeField" :
          let result$2 = Formality.validateFieldOnBlurWithoutValidator(state.input.youTube, state.fieldsStatuses.youTube, status => {
            let init = state.fieldsStatuses;
            return {
              yelp: init.yelp,
              tikTok: init.tikTok,
              youTube: status,
              linkedIn: init.linkedIn,
              instagram: init.instagram,
              facebook: init.facebook,
              twitter: init.twitter,
              bio: init.bio,
              headshot: init.headshot,
              licenseNumber: init.licenseNumber,
              title: init.title,
              lastName: init.lastName,
              firstName: init.firstName
            };
          });
          if (result$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$2,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurLinkedInField" :
          let result$3 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.linkedIn, validators_linkedIn, status => {
            let init = state.fieldsStatuses;
            return {
              yelp: init.yelp,
              tikTok: init.tikTok,
              youTube: init.youTube,
              linkedIn: status,
              instagram: init.instagram,
              facebook: init.facebook,
              twitter: init.twitter,
              bio: init.bio,
              headshot: init.headshot,
              licenseNumber: init.licenseNumber,
              title: init.title,
              lastName: init.lastName,
              firstName: init.firstName
            };
          });
          if (result$3 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$3,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurInstagramField" :
          let result$4 = Formality.validateFieldOnBlurWithoutValidator(state.input.instagram, state.fieldsStatuses.instagram, status => {
            let init = state.fieldsStatuses;
            return {
              yelp: init.yelp,
              tikTok: init.tikTok,
              youTube: init.youTube,
              linkedIn: init.linkedIn,
              instagram: status,
              facebook: init.facebook,
              twitter: init.twitter,
              bio: init.bio,
              headshot: init.headshot,
              licenseNumber: init.licenseNumber,
              title: init.title,
              lastName: init.lastName,
              firstName: init.firstName
            };
          });
          if (result$4 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$4,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurFacebookField" :
          let result$5 = Formality.validateFieldOnBlurWithoutValidator(state.input.facebook, state.fieldsStatuses.facebook, status => {
            let init = state.fieldsStatuses;
            return {
              yelp: init.yelp,
              tikTok: init.tikTok,
              youTube: init.youTube,
              linkedIn: init.linkedIn,
              instagram: init.instagram,
              facebook: status,
              twitter: init.twitter,
              bio: init.bio,
              headshot: init.headshot,
              licenseNumber: init.licenseNumber,
              title: init.title,
              lastName: init.lastName,
              firstName: init.firstName
            };
          });
          if (result$5 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$5,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurTwitterField" :
          let result$6 = Formality.validateFieldOnBlurWithoutValidator(state.input.twitter, state.fieldsStatuses.twitter, status => {
            let init = state.fieldsStatuses;
            return {
              yelp: init.yelp,
              tikTok: init.tikTok,
              youTube: init.youTube,
              linkedIn: init.linkedIn,
              instagram: init.instagram,
              facebook: init.facebook,
              twitter: status,
              bio: init.bio,
              headshot: init.headshot,
              licenseNumber: init.licenseNumber,
              title: init.title,
              lastName: init.lastName,
              firstName: init.firstName
            };
          });
          if (result$6 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$6,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurBioField" :
          let result$7 = Formality.validateFieldOnBlurWithoutValidator(state.input.bio, state.fieldsStatuses.bio, status => {
            let init = state.fieldsStatuses;
            return {
              yelp: init.yelp,
              tikTok: init.tikTok,
              youTube: init.youTube,
              linkedIn: init.linkedIn,
              instagram: init.instagram,
              facebook: init.facebook,
              twitter: init.twitter,
              bio: status,
              headshot: init.headshot,
              licenseNumber: init.licenseNumber,
              title: init.title,
              lastName: init.lastName,
              firstName: init.firstName
            };
          });
          if (result$7 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$7,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurHeadshotField" :
          let result$8 = Formality.validateFieldOnBlurWithoutValidator(state.input.headshot, state.fieldsStatuses.headshot, status => {
            let init = state.fieldsStatuses;
            return {
              yelp: init.yelp,
              tikTok: init.tikTok,
              youTube: init.youTube,
              linkedIn: init.linkedIn,
              instagram: init.instagram,
              facebook: init.facebook,
              twitter: init.twitter,
              bio: init.bio,
              headshot: status,
              licenseNumber: init.licenseNumber,
              title: init.title,
              lastName: init.lastName,
              firstName: init.firstName
            };
          });
          if (result$8 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$8,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurLicenseNumberField" :
          let result$9 = Formality.validateFieldOnBlurWithoutValidator(state.input.licenseNumber, state.fieldsStatuses.licenseNumber, status => {
            let init = state.fieldsStatuses;
            return {
              yelp: init.yelp,
              tikTok: init.tikTok,
              youTube: init.youTube,
              linkedIn: init.linkedIn,
              instagram: init.instagram,
              facebook: init.facebook,
              twitter: init.twitter,
              bio: init.bio,
              headshot: init.headshot,
              licenseNumber: status,
              title: init.title,
              lastName: init.lastName,
              firstName: init.firstName
            };
          });
          if (result$9 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$9,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurTitleField" :
          let result$10 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.title, validators_title, status => {
            let init = state.fieldsStatuses;
            return {
              yelp: init.yelp,
              tikTok: init.tikTok,
              youTube: init.youTube,
              linkedIn: init.linkedIn,
              instagram: init.instagram,
              facebook: init.facebook,
              twitter: init.twitter,
              bio: init.bio,
              headshot: init.headshot,
              licenseNumber: init.licenseNumber,
              title: status,
              lastName: init.lastName,
              firstName: init.firstName
            };
          });
          if (result$10 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$10,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurLastNameField" :
          let result$11 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.lastName, validators_lastName, status => {
            let init = state.fieldsStatuses;
            return {
              yelp: init.yelp,
              tikTok: init.tikTok,
              youTube: init.youTube,
              linkedIn: init.linkedIn,
              instagram: init.instagram,
              facebook: init.facebook,
              twitter: init.twitter,
              bio: init.bio,
              headshot: init.headshot,
              licenseNumber: init.licenseNumber,
              title: init.title,
              lastName: status,
              firstName: init.firstName
            };
          });
          if (result$11 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$11,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurFirstNameField" :
          let result$12 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.firstName, validators_firstName, status => {
            let init = state.fieldsStatuses;
            return {
              yelp: init.yelp,
              tikTok: init.tikTok,
              youTube: init.youTube,
              linkedIn: init.linkedIn,
              instagram: init.instagram,
              facebook: init.facebook,
              twitter: init.twitter,
              bio: init.bio,
              headshot: init.headshot,
              licenseNumber: init.licenseNumber,
              title: init.title,
              lastName: init.lastName,
              firstName: status
            };
          });
          if (result$12 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$12,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "Submit" :
          let match = state.formStatus;
          if (typeof match === "object" && match.TAG === "Submitting") {
            return "NoUpdate";
          }
          let match$1 = validateForm(state.input, validators, state.fieldsStatuses);
          if (match$1.TAG !== "Valid") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: match$1.fieldsStatuses,
                collectionsStatuses: match$1.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: "AttemptedToSubmit"
              }
            };
          }
          let output = match$1.output;
          let error = state.formStatus;
          let tmp;
          tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : Primitive_option.some(error._0);
          return {
            TAG: "UpdateWithSideEffects",
            _0: {
              input: state.input,
              fieldsStatuses: match$1.fieldsStatuses,
              collectionsStatuses: match$1.collectionsStatuses,
              formStatus: {
                TAG: "Submitting",
                _0: tmp
              },
              submissionStatus: "AttemptedToSubmit"
            },
            _1: param => {
              let dispatch = param.dispatch;
              onSubmit(output, {
                notifyOnSuccess: input => dispatch({
                  TAG: "SetSubmittedStatus",
                  _0: input
                }),
                notifyOnFailure: error => dispatch({
                  TAG: "SetSubmissionFailedStatus",
                  _0: error
                }),
                reset: () => dispatch("Reset"),
                dismissSubmissionResult: () => dispatch("DismissSubmissionResult")
              });
            }
          };
          break;
        case "DismissSubmissionError" :
          let match$2 = state.formStatus;
          if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
            return "NoUpdate";
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "DismissSubmissionResult" :
          let match$3 = state.formStatus;
          if (typeof match$3 !== "object") {
            if (match$3 === "Editing") {
              return "NoUpdate";
            }
          } else if (match$3.TAG === "Submitting") {
            return "NoUpdate";
          }
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: "Editing",
              submissionStatus: state.submissionStatus
            }
          };
        case "Reset" :
          return {
            TAG: "Update",
            _0: initialState(initialInput)
          };
      }
    } else {
      switch (action.TAG) {
        case "UpdateYelpField" :
          let nextInput = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput,
              fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput.yelp, status => {
                let init = state.fieldsStatuses;
                return {
                  yelp: status,
                  tikTok: init.tikTok,
                  youTube: init.youTube,
                  linkedIn: init.linkedIn,
                  instagram: init.instagram,
                  facebook: init.facebook,
                  twitter: init.twitter,
                  bio: init.bio,
                  headshot: init.headshot,
                  licenseNumber: init.licenseNumber,
                  title: init.title,
                  lastName: init.lastName,
                  firstName: init.firstName
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateTikTokField" :
          let nextInput$1 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$1,
              fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$1.tikTok, status => {
                let init = state.fieldsStatuses;
                return {
                  yelp: init.yelp,
                  tikTok: status,
                  youTube: init.youTube,
                  linkedIn: init.linkedIn,
                  instagram: init.instagram,
                  facebook: init.facebook,
                  twitter: init.twitter,
                  bio: init.bio,
                  headshot: init.headshot,
                  licenseNumber: init.licenseNumber,
                  title: init.title,
                  lastName: init.lastName,
                  firstName: init.firstName
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateYouTubeField" :
          let nextInput$2 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$2,
              fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$2.youTube, status => {
                let init = state.fieldsStatuses;
                return {
                  yelp: init.yelp,
                  tikTok: init.tikTok,
                  youTube: status,
                  linkedIn: init.linkedIn,
                  instagram: init.instagram,
                  facebook: init.facebook,
                  twitter: init.twitter,
                  bio: init.bio,
                  headshot: init.headshot,
                  licenseNumber: init.licenseNumber,
                  title: init.title,
                  lastName: init.lastName,
                  firstName: init.firstName
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateLinkedInField" :
          let nextInput$3 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$3,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$3, state.fieldsStatuses.linkedIn, state.submissionStatus, validators_linkedIn, status => {
                let init = state.fieldsStatuses;
                return {
                  yelp: init.yelp,
                  tikTok: init.tikTok,
                  youTube: init.youTube,
                  linkedIn: status,
                  instagram: init.instagram,
                  facebook: init.facebook,
                  twitter: init.twitter,
                  bio: init.bio,
                  headshot: init.headshot,
                  licenseNumber: init.licenseNumber,
                  title: init.title,
                  lastName: init.lastName,
                  firstName: init.firstName
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateInstagramField" :
          let nextInput$4 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$4,
              fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$4.instagram, status => {
                let init = state.fieldsStatuses;
                return {
                  yelp: init.yelp,
                  tikTok: init.tikTok,
                  youTube: init.youTube,
                  linkedIn: init.linkedIn,
                  instagram: status,
                  facebook: init.facebook,
                  twitter: init.twitter,
                  bio: init.bio,
                  headshot: init.headshot,
                  licenseNumber: init.licenseNumber,
                  title: init.title,
                  lastName: init.lastName,
                  firstName: init.firstName
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateFacebookField" :
          let nextInput$5 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$5,
              fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$5.facebook, status => {
                let init = state.fieldsStatuses;
                return {
                  yelp: init.yelp,
                  tikTok: init.tikTok,
                  youTube: init.youTube,
                  linkedIn: init.linkedIn,
                  instagram: init.instagram,
                  facebook: status,
                  twitter: init.twitter,
                  bio: init.bio,
                  headshot: init.headshot,
                  licenseNumber: init.licenseNumber,
                  title: init.title,
                  lastName: init.lastName,
                  firstName: init.firstName
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateTwitterField" :
          let nextInput$6 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$6,
              fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$6.twitter, status => {
                let init = state.fieldsStatuses;
                return {
                  yelp: init.yelp,
                  tikTok: init.tikTok,
                  youTube: init.youTube,
                  linkedIn: init.linkedIn,
                  instagram: init.instagram,
                  facebook: init.facebook,
                  twitter: status,
                  bio: init.bio,
                  headshot: init.headshot,
                  licenseNumber: init.licenseNumber,
                  title: init.title,
                  lastName: init.lastName,
                  firstName: init.firstName
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateBioField" :
          let nextInput$7 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$7,
              fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$7.bio, status => {
                let init = state.fieldsStatuses;
                return {
                  yelp: init.yelp,
                  tikTok: init.tikTok,
                  youTube: init.youTube,
                  linkedIn: init.linkedIn,
                  instagram: init.instagram,
                  facebook: init.facebook,
                  twitter: init.twitter,
                  bio: status,
                  headshot: init.headshot,
                  licenseNumber: init.licenseNumber,
                  title: init.title,
                  lastName: init.lastName,
                  firstName: init.firstName
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateHeadshotField" :
          let nextInput$8 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$8,
              fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$8.headshot, status => {
                let init = state.fieldsStatuses;
                return {
                  yelp: init.yelp,
                  tikTok: init.tikTok,
                  youTube: init.youTube,
                  linkedIn: init.linkedIn,
                  instagram: init.instagram,
                  facebook: init.facebook,
                  twitter: init.twitter,
                  bio: init.bio,
                  headshot: status,
                  licenseNumber: init.licenseNumber,
                  title: init.title,
                  lastName: init.lastName,
                  firstName: init.firstName
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateLicenseNumberField" :
          let nextInput$9 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$9,
              fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$9.licenseNumber, status => {
                let init = state.fieldsStatuses;
                return {
                  yelp: init.yelp,
                  tikTok: init.tikTok,
                  youTube: init.youTube,
                  linkedIn: init.linkedIn,
                  instagram: init.instagram,
                  facebook: init.facebook,
                  twitter: init.twitter,
                  bio: init.bio,
                  headshot: init.headshot,
                  licenseNumber: status,
                  title: init.title,
                  lastName: init.lastName,
                  firstName: init.firstName
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateTitleField" :
          let nextInput$10 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$10,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$10, state.fieldsStatuses.title, state.submissionStatus, validators_title, status => {
                let init = state.fieldsStatuses;
                return {
                  yelp: init.yelp,
                  tikTok: init.tikTok,
                  youTube: init.youTube,
                  linkedIn: init.linkedIn,
                  instagram: init.instagram,
                  facebook: init.facebook,
                  twitter: init.twitter,
                  bio: init.bio,
                  headshot: init.headshot,
                  licenseNumber: init.licenseNumber,
                  title: status,
                  lastName: init.lastName,
                  firstName: init.firstName
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateLastNameField" :
          let nextInput$11 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$11,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$11, state.fieldsStatuses.lastName, state.submissionStatus, validators_lastName, status => {
                let init = state.fieldsStatuses;
                return {
                  yelp: init.yelp,
                  tikTok: init.tikTok,
                  youTube: init.youTube,
                  linkedIn: init.linkedIn,
                  instagram: init.instagram,
                  facebook: init.facebook,
                  twitter: init.twitter,
                  bio: init.bio,
                  headshot: init.headshot,
                  licenseNumber: init.licenseNumber,
                  title: init.title,
                  lastName: status,
                  firstName: init.firstName
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateFirstNameField" :
          let nextInput$12 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$12,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$12, state.fieldsStatuses.firstName, state.submissionStatus, validators_firstName, status => {
                let init = state.fieldsStatuses;
                return {
                  yelp: init.yelp,
                  tikTok: init.tikTok,
                  youTube: init.youTube,
                  linkedIn: init.linkedIn,
                  instagram: init.instagram,
                  facebook: init.facebook,
                  twitter: init.twitter,
                  bio: init.bio,
                  headshot: init.headshot,
                  licenseNumber: init.licenseNumber,
                  title: init.title,
                  lastName: init.lastName,
                  firstName: status
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "SetSubmittedStatus" :
          let input = action._0;
          if (input !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: input,
                fieldsStatuses: initialFieldsStatuses(input),
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: initialFieldsStatuses(state.input),
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "SetSubmissionFailedStatus" :
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: {
                TAG: "SubmissionFailed",
                _0: action._0
              },
              submissionStatus: state.submissionStatus
            }
          };
        case "MapSubmissionError" :
          let map = action._0;
          let error$1 = state.formStatus;
          if (typeof error$1 !== "object") {
            return "NoUpdate";
          }
          if (error$1.TAG !== "Submitting") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "SubmissionFailed",
                  _0: map(error$1._0)
                },
                submissionStatus: state.submissionStatus
              }
            };
          }
          let error$2 = error$1._0;
          if (error$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "Submitting",
                  _0: Primitive_option.some(map(Primitive_option.valFromOption(error$2)))
                },
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
      }
    }
  });
  let dispatch = match[1];
  let state = match[0];
  let match$1 = state.formStatus;
  let tmp;
  tmp = typeof match$1 !== "object" ? false : match$1.TAG === "Submitting";
  return {
    updateYelp: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateYelpField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateTikTok: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateTikTokField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateYouTube: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateYouTubeField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateLinkedIn: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateLinkedInField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateInstagram: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateInstagramField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateFacebook: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateFacebookField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateTwitter: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateTwitterField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateBio: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateBioField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateHeadshot: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateHeadshotField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateLicenseNumber: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateLicenseNumberField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateTitle: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateTitleField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateLastName: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateLastNameField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateFirstName: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateFirstNameField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    blurYelp: () => dispatch("BlurYelpField"),
    blurTikTok: () => dispatch("BlurTikTokField"),
    blurYouTube: () => dispatch("BlurYouTubeField"),
    blurLinkedIn: () => dispatch("BlurLinkedInField"),
    blurInstagram: () => dispatch("BlurInstagramField"),
    blurFacebook: () => dispatch("BlurFacebookField"),
    blurTwitter: () => dispatch("BlurTwitterField"),
    blurBio: () => dispatch("BlurBioField"),
    blurHeadshot: () => dispatch("BlurHeadshotField"),
    blurLicenseNumber: () => dispatch("BlurLicenseNumberField"),
    blurTitle: () => dispatch("BlurTitleField"),
    blurLastName: () => dispatch("BlurLastNameField"),
    blurFirstName: () => dispatch("BlurFirstNameField"),
    yelpResult: Formality.exposeFieldResult(state.fieldsStatuses.yelp),
    tikTokResult: Formality.exposeFieldResult(state.fieldsStatuses.tikTok),
    youTubeResult: Formality.exposeFieldResult(state.fieldsStatuses.youTube),
    linkedInResult: Formality.exposeFieldResult(state.fieldsStatuses.linkedIn),
    instagramResult: Formality.exposeFieldResult(state.fieldsStatuses.instagram),
    facebookResult: Formality.exposeFieldResult(state.fieldsStatuses.facebook),
    twitterResult: Formality.exposeFieldResult(state.fieldsStatuses.twitter),
    bioResult: Formality.exposeFieldResult(state.fieldsStatuses.bio),
    headshotResult: Formality.exposeFieldResult(state.fieldsStatuses.headshot),
    licenseNumberResult: Formality.exposeFieldResult(state.fieldsStatuses.licenseNumber),
    titleResult: Formality.exposeFieldResult(state.fieldsStatuses.title),
    lastNameResult: Formality.exposeFieldResult(state.fieldsStatuses.lastName),
    firstNameResult: Formality.exposeFieldResult(state.fieldsStatuses.firstName),
    input: state.input,
    status: state.formStatus,
    dirty: () => {
      let match = state.fieldsStatuses;
      let exit = 0;
      let tmp = match.yelp;
      if (typeof tmp !== "object") {
        let tmp$1 = match.tikTok;
        if (typeof tmp$1 !== "object") {
          let tmp$2 = match.youTube;
          if (typeof tmp$2 !== "object") {
            let tmp$3 = match.linkedIn;
            if (typeof tmp$3 !== "object") {
              let tmp$4 = match.instagram;
              if (typeof tmp$4 !== "object") {
                let tmp$5 = match.facebook;
                if (typeof tmp$5 !== "object") {
                  let tmp$6 = match.twitter;
                  if (typeof tmp$6 !== "object") {
                    let tmp$7 = match.bio;
                    if (typeof tmp$7 !== "object") {
                      let tmp$8 = match.headshot;
                      if (typeof tmp$8 !== "object") {
                        let tmp$9 = match.licenseNumber;
                        if (typeof tmp$9 !== "object") {
                          let tmp$10 = match.title;
                          if (typeof tmp$10 !== "object") {
                            let tmp$11 = match.lastName;
                            if (typeof tmp$11 !== "object") {
                              let tmp$12 = match.firstName;
                              if (typeof tmp$12 !== "object") {
                                return false;
                              }
                              exit = 1;
                            } else {
                              exit = 1;
                            }
                          } else {
                            exit = 1;
                          }
                        } else {
                          exit = 1;
                        }
                      } else {
                        exit = 1;
                      }
                    } else {
                      exit = 1;
                    }
                  } else {
                    exit = 1;
                  }
                } else {
                  exit = 1;
                }
              } else {
                exit = 1;
              }
            } else {
              exit = 1;
            }
          } else {
            exit = 1;
          }
        } else {
          exit = 1;
        }
      } else {
        exit = 1;
      }
      if (exit === 1) {
        let exit$1 = 0;
        exit$1 = 2;
        if (exit$1 === 2) {
          let exit$2 = 0;
          exit$2 = 3;
          if (exit$2 === 3) {
            return true;
          }
        }
      }
    },
    valid: () => {
      let match = validateForm(state.input, validators, state.fieldsStatuses);
      return match.TAG === "Valid";
    },
    submitting: tmp,
    submit: () => dispatch("Submit"),
    dismissSubmissionError: () => dispatch("DismissSubmissionError"),
    dismissSubmissionResult: () => dispatch("DismissSubmissionResult"),
    mapSubmissionError: map => dispatch({
      TAG: "MapSubmissionError",
      _0: map
    }),
    reset: () => dispatch("Reset")
  };
}

let Config = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialFieldStatuses_xxx: initialFieldStatuses_xxx,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

let initialInput = {
  firstName: "",
  lastName: "",
  title: "",
  licenseNumber: "",
  headshot: undefined,
  bio: undefined,
  twitter: "",
  facebook: "",
  instagram: "",
  linkedIn: "",
  youTube: "",
  tikTok: "",
  yelp: ""
};

function messageToString(v) {
  if (typeof v === "object") {
    return v.VAL;
  } else {
    return "is required";
  }
}

function UnifiedAddDisplayOnlyMember$Form$FieldValidationMessage(props) {
  return JsxRuntime.jsx(FormalityUI.FieldValidationMessage.make, {
    messageToString: messageToString,
    result: props.result
  });
}

let FieldValidationMessage = {
  make: UnifiedAddDisplayOnlyMember$Form$FieldValidationMessage
};

function UnifiedAddDisplayOnlyMember$Form$InputField(props) {
  let status = props.status;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Form__Label.make, {
          labelText: props.labelText
        }),
        className: "pt-2"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Form__TextInput.make, {
            type: props._type,
            placeholderText: props.placeholder,
            onChange: props.onChange,
            onBlur: props.onBlur,
            status: FormalityUI.UIKitStatus.ofOptFieldResult(status),
            value: props.value
          }),
          Stdlib_Option.getOr(Stdlib_Option.map(props.helpText, text => JsxRuntime.jsx("div", {
            children: text,
            className: "text-base text-gray-500"
          })), null),
          JsxRuntime.jsx(UnifiedAddDisplayOnlyMember$Form$FieldValidationMessage, {
            result: status
          })
        ],
        className: "mt-2 sm:col-span-2 sm:mt-0 sm:max-w-xs space-y-3"
      })
    ],
    className: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6"
  });
}

let InputField = {
  make: UnifiedAddDisplayOnlyMember$Form$InputField
};

function UnifiedAddDisplayOnlyMember$Form$HeadshotField(props) {
  let form = props.form;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Form__Label.make, {
          labelText: "Headshot"
        }),
        className: "pt-2"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "w-16 h-16 rounded-full",
            src: Stdlib_Option.getOr(Stdlib_Option.map(form.input.headshot, headshot => headshot.croppedPhotoDataUrl), AvatarSrcUrl.placeholder)
          }),
          JsxRuntime.jsx(ProfilePhotoInput.make, {
            onSubmit: (param, param$1) => {
              form.updateHeadshot((input, value) => ({
                firstName: input.firstName,
                lastName: input.lastName,
                title: input.title,
                licenseNumber: input.licenseNumber,
                headshot: value,
                bio: input.bio,
                twitter: input.twitter,
                facebook: input.facebook,
                instagram: input.instagram,
                linkedIn: input.linkedIn,
                youTube: input.youTube,
                tikTok: input.tikTok,
                yelp: input.yelp
              }), {
                originalPhoto: param.originalPhoto,
                croppedPhoto: param.croppedPhoto,
                croppedPhotoDataUrl: param.croppedPhotoDataUrl
              });
              param$1.notifyOnSuccess();
            },
            buttonText: "Add photo"
          })
        ],
        className: "mt-2 sm:col-span-2 sm:mt-0 space-y-3 flex gap-6 items-center"
      })
    ],
    className: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6"
  });
}

let HeadshotField = {
  make: UnifiedAddDisplayOnlyMember$Form$HeadshotField
};

function UnifiedAddDisplayOnlyMember$Form$BioField(props) {
  let form = props.form;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Form__Label.make, {
          labelText: "Bio"
        }),
        className: "pt-2"
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(RichTextEditorV5.make, {
          initialContent: undefined,
          onChange: value => form.updateBio((input, value) => ({
            firstName: input.firstName,
            lastName: input.lastName,
            title: input.title,
            licenseNumber: input.licenseNumber,
            headshot: input.headshot,
            bio: value,
            twitter: input.twitter,
            facebook: input.facebook,
            instagram: input.instagram,
            linkedIn: input.linkedIn,
            youTube: input.youTube,
            tikTok: input.tikTok,
            yelp: input.yelp
          }), value),
          onBlur: param => form.blurBio(),
          toolbar: "withoutHeaders"
        }),
        className: "mt-2 sm:col-span-2 sm:mt-0 space-y-3"
      })
    ],
    className: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6"
  });
}

let BioField = {
  make: UnifiedAddDisplayOnlyMember$Form$BioField
};

function UnifiedAddDisplayOnlyMember$Form(props) {
  let match = useAddDisplayMember();
  let save = match[0];
  let form = useForm(initialInput, (values, param) => {
    let notifyOnFailure = param.notifyOnFailure;
    let image = Stdlib_Option.map(values.headshot, headshot => UnifiedProfileSave.fromPhoto(headshot.croppedPhoto));
    let originalImage = Stdlib_Option.map(values.headshot, headshot => UnifiedProfileSave.fromPhoto(headshot.originalPhoto));
    save({
      bio: Stdlib_Option.getOr(values.bio, ""),
      firstName: values.firstName,
      image: image,
      lastName: values.lastName,
      licenseNumber: values.licenseNumber,
      originalImage: originalImage,
      social: {
        facebook: values.facebook,
        instagram: values.instagram,
        linkedIn: values.linkedIn,
        tikTok: values.tikTok,
        twitter: values.twitter,
        yelp: values.yelp,
        youTube: values.youTube
      },
      title: values.title
    }, () => Next.SingletonRouter.replace("/account/account_profile/members", undefined, undefined), param => notifyOnFailure());
  });
  let match$1 = form.status;
  let tmp;
  tmp = typeof match$1 !== "object" || match$1.TAG !== "SubmissionFailed" ? null : JsxRuntime.jsx(Alert.$$Error.make, {
      title: "There was an error updating your account. Please try again"
    });
  return JsxRuntime.jsxs("form", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(UnifiedAddDisplayOnlyMember$Form$InputField, {
                onChange: event => form.updateFirstName((input, value) => ({
                  firstName: value,
                  lastName: input.lastName,
                  title: input.title,
                  licenseNumber: input.licenseNumber,
                  headshot: input.headshot,
                  bio: input.bio,
                  twitter: input.twitter,
                  facebook: input.facebook,
                  instagram: input.instagram,
                  linkedIn: input.linkedIn,
                  youTube: input.youTube,
                  tikTok: input.tikTok,
                  yelp: input.yelp
                }), event.target.value),
                onBlur: param => form.blurFirstName(),
                value: form.input.firstName,
                status: form.firstNameResult,
                labelText: "First name"
              }),
              JsxRuntime.jsx(UnifiedAddDisplayOnlyMember$Form$InputField, {
                onChange: event => form.updateLastName((input, value) => ({
                  firstName: input.firstName,
                  lastName: value,
                  title: input.title,
                  licenseNumber: input.licenseNumber,
                  headshot: input.headshot,
                  bio: input.bio,
                  twitter: input.twitter,
                  facebook: input.facebook,
                  instagram: input.instagram,
                  linkedIn: input.linkedIn,
                  youTube: input.youTube,
                  tikTok: input.tikTok,
                  yelp: input.yelp
                }), event.target.value),
                onBlur: param => form.blurLastName(),
                value: form.input.lastName,
                status: form.lastNameResult,
                labelText: "Last name"
              }),
              JsxRuntime.jsx(UnifiedAddDisplayOnlyMember$Form$InputField, {
                onChange: event => form.updateTitle((input, value) => ({
                  firstName: input.firstName,
                  lastName: input.lastName,
                  title: value,
                  licenseNumber: input.licenseNumber,
                  headshot: input.headshot,
                  bio: input.bio,
                  twitter: input.twitter,
                  facebook: input.facebook,
                  instagram: input.instagram,
                  linkedIn: input.linkedIn,
                  youTube: input.youTube,
                  tikTok: input.tikTok,
                  yelp: input.yelp
                }), event.target.value),
                onBlur: param => form.blurTitle(),
                value: form.input.title,
                status: form.titleResult,
                labelText: "Title"
              }),
              JsxRuntime.jsx(UnifiedAddDisplayOnlyMember$Form$InputField, {
                onChange: event => form.updateLicenseNumber((input, value) => ({
                  firstName: input.firstName,
                  lastName: input.lastName,
                  title: input.title,
                  licenseNumber: value,
                  headshot: input.headshot,
                  bio: input.bio,
                  twitter: input.twitter,
                  facebook: input.facebook,
                  instagram: input.instagram,
                  linkedIn: input.linkedIn,
                  youTube: input.youTube,
                  tikTok: input.tikTok,
                  yelp: input.yelp
                }), event.target.value),
                onBlur: param => form.blurLicenseNumber(),
                value: form.input.licenseNumber,
                status: form.licenseNumberResult,
                labelText: "License number"
              }),
              JsxRuntime.jsx(UnifiedAddDisplayOnlyMember$Form$HeadshotField, {
                form: form
              }),
              JsxRuntime.jsx(UnifiedAddDisplayOnlyMember$Form$BioField, {
                form: form
              })
            ],
            className: "space-y-8 border-b border-zinc-200 pb-12 sm:space-y-0 sm:divide-y sm:divide-zinc-200 sm:pb-0"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("h3", {
                children: "Social accounts",
                className: "text-lg font-semibold leading-7 text-gray-900 sm:gap-4 sm:py-6"
              }),
              JsxRuntime.jsx(UnifiedAddDisplayOnlyMember$Form$InputField, {
                onChange: event => form.updateTwitter((input, value) => ({
                  firstName: input.firstName,
                  lastName: input.lastName,
                  title: input.title,
                  licenseNumber: input.licenseNumber,
                  headshot: input.headshot,
                  bio: input.bio,
                  twitter: value,
                  facebook: input.facebook,
                  instagram: input.instagram,
                  linkedIn: input.linkedIn,
                  youTube: input.youTube,
                  tikTok: input.tikTok,
                  yelp: input.yelp
                }), event.target.value),
                onBlur: param => form.blurTwitter(),
                value: form.input.twitter,
                status: form.twitterResult,
                labelText: "Twitter",
                placeholder: "URL or username"
              }),
              JsxRuntime.jsx(UnifiedAddDisplayOnlyMember$Form$InputField, {
                onChange: event => form.updateFacebook((input, value) => ({
                  firstName: input.firstName,
                  lastName: input.lastName,
                  title: input.title,
                  licenseNumber: input.licenseNumber,
                  headshot: input.headshot,
                  bio: input.bio,
                  twitter: input.twitter,
                  facebook: value,
                  instagram: input.instagram,
                  linkedIn: input.linkedIn,
                  youTube: input.youTube,
                  tikTok: input.tikTok,
                  yelp: input.yelp
                }), event.target.value),
                onBlur: param => form.blurFacebook(),
                value: form.input.facebook,
                status: form.facebookResult,
                labelText: "Facebook",
                placeholder: "URL or username"
              }),
              JsxRuntime.jsx(UnifiedAddDisplayOnlyMember$Form$InputField, {
                onChange: event => form.updateInstagram((input, value) => ({
                  firstName: input.firstName,
                  lastName: input.lastName,
                  title: input.title,
                  licenseNumber: input.licenseNumber,
                  headshot: input.headshot,
                  bio: input.bio,
                  twitter: input.twitter,
                  facebook: input.facebook,
                  instagram: value,
                  linkedIn: input.linkedIn,
                  youTube: input.youTube,
                  tikTok: input.tikTok,
                  yelp: input.yelp
                }), event.target.value),
                onBlur: param => form.blurInstagram(),
                value: form.input.instagram,
                status: form.instagramResult,
                labelText: "Instagram",
                placeholder: "URL or username"
              }),
              JsxRuntime.jsx(UnifiedAddDisplayOnlyMember$Form$InputField, {
                onChange: event => form.updateLinkedIn((input, value) => ({
                  firstName: input.firstName,
                  lastName: input.lastName,
                  title: input.title,
                  licenseNumber: input.licenseNumber,
                  headshot: input.headshot,
                  bio: input.bio,
                  twitter: input.twitter,
                  facebook: input.facebook,
                  instagram: input.instagram,
                  linkedIn: value,
                  youTube: input.youTube,
                  tikTok: input.tikTok,
                  yelp: input.yelp
                }), event.target.value),
                onBlur: param => form.blurLinkedIn(),
                value: form.input.linkedIn,
                status: form.linkedInResult,
                labelText: "LinkedIn",
                placeholder: "https://www.linkedin.com/in/your-name"
              }),
              JsxRuntime.jsx(UnifiedAddDisplayOnlyMember$Form$InputField, {
                onChange: event => form.updateYouTube((input, value) => ({
                  firstName: input.firstName,
                  lastName: input.lastName,
                  title: input.title,
                  licenseNumber: input.licenseNumber,
                  headshot: input.headshot,
                  bio: input.bio,
                  twitter: input.twitter,
                  facebook: input.facebook,
                  instagram: input.instagram,
                  linkedIn: input.linkedIn,
                  youTube: value,
                  tikTok: input.tikTok,
                  yelp: input.yelp
                }), event.target.value),
                onBlur: param => form.blurYouTube(),
                value: form.input.youTube,
                status: form.youTubeResult,
                labelText: "YouTube",
                placeholder: "URL or username"
              }),
              JsxRuntime.jsx(UnifiedAddDisplayOnlyMember$Form$InputField, {
                onChange: event => form.updateTikTok((input, value) => ({
                  firstName: input.firstName,
                  lastName: input.lastName,
                  title: input.title,
                  licenseNumber: input.licenseNumber,
                  headshot: input.headshot,
                  bio: input.bio,
                  twitter: input.twitter,
                  facebook: input.facebook,
                  instagram: input.instagram,
                  linkedIn: input.linkedIn,
                  youTube: input.youTube,
                  tikTok: value,
                  yelp: input.yelp
                }), event.target.value),
                onBlur: param => form.blurTikTok(),
                value: form.input.tikTok,
                status: form.tikTokResult,
                labelText: "TikTok",
                placeholder: "URL or username"
              }),
              JsxRuntime.jsx(UnifiedAddDisplayOnlyMember$Form$InputField, {
                onChange: event => form.updateYelp((input, value) => ({
                  firstName: input.firstName,
                  lastName: input.lastName,
                  title: input.title,
                  licenseNumber: input.licenseNumber,
                  headshot: input.headshot,
                  bio: input.bio,
                  twitter: input.twitter,
                  facebook: input.facebook,
                  instagram: input.instagram,
                  linkedIn: input.linkedIn,
                  youTube: input.youTube,
                  tikTok: input.tikTok,
                  yelp: value
                }), event.target.value),
                onBlur: param => form.blurYelp(),
                value: form.input.yelp,
                status: form.yelpResult,
                labelText: "Yelp",
                placeholder: "URL or username"
              })
            ],
            className: "space-y-8 border-b border-zinc-200 pb-12 sm:space-y-0 sm:divide-y sm:divide-zinc-200 sm:pb-0"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                disabled: match[1] || form.submitting,
                children: "Add Display-only member"
              }),
              JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                href: "/account/account_profile/members",
                children: "Cancel"
              }),
              JsxRuntime.jsx("div", {
                children: tmp,
                role: "status"
              })
            ],
            className: "flex flex-col sm:flex-row gap-4 items-center"
          })
        ],
        className: "space-y-6"
      }),
      match[2]
    ],
    onSubmit: event => {
      event.preventDefault();
      form.submit();
    }
  });
}

let Form = {
  Config: Config,
  initialInput: initialInput,
  messageToString: messageToString,
  FieldValidationMessage: FieldValidationMessage,
  InputField: InputField,
  HeadshotField: HeadshotField,
  BioField: BioField,
  make: UnifiedAddDisplayOnlyMember$Form
};

let convertVariables$1 = UnifiedAddDisplayOnlyMemberQuery_graphql.Internal.convertVariables;

let convertResponse$1 = UnifiedAddDisplayOnlyMemberQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse$1 = UnifiedAddDisplayOnlyMemberQuery_graphql.Internal.convertWrapRawResponse;

let use$1 = RescriptRelay_Query.useQuery(convertVariables$1, UnifiedAddDisplayOnlyMemberQuery_graphql.node, convertResponse$1);

let useLoader = RescriptRelay_Query.useLoader(convertVariables$1, UnifiedAddDisplayOnlyMemberQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(UnifiedAddDisplayOnlyMemberQuery_graphql.node, convertResponse$1, prim => prim);

let fetch = RescriptRelay_Query.fetch_(UnifiedAddDisplayOnlyMemberQuery_graphql.node, convertResponse$1, convertVariables$1);

let fetchPromised = RescriptRelay_Query.fetchPromised(UnifiedAddDisplayOnlyMemberQuery_graphql.node, convertResponse$1, convertVariables$1);

let retain = RescriptRelay_Query.retain(UnifiedAddDisplayOnlyMemberQuery_graphql.node, convertVariables$1);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  use: use$1,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function UnifiedAddDisplayOnlyMember$Page(props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(UnifiedProfileSettingsUI.SubpageHeader.make, {
        title: "Add Display-only member",
        rootName: "Members",
        rootUrl: "/account/account_profile/members",
        url: "/account/account_profile/members/new"
      }),
      JsxRuntime.jsx(UnifiedAddDisplayOnlyMember$Form, {})
    ],
    className: "bg-white p-6 shadow-sm rounded space-y-8"
  });
}

let Page = {
  make: UnifiedAddDisplayOnlyMember$Page
};

function UnifiedAddDisplayOnlyMember(props) {
  let match = use$1(undefined, undefined, undefined, undefined);
  let member = match.currentAccountV5.profile;
  switch (member.__typename) {
    case "IndividualAccountProfile" :
      return JsxRuntime.jsx(Redirect.make, {
        path: "/account/account_profile"
      });
    case "TeamAccountProfile" :
      return JsxRuntime.jsx(UnifiedAddDisplayOnlyMember$Page, {});
    case "__unselected" :
      return UnselectedUnionMemberError.raise(`Unselected account profile member: ` + member._0);
  }
}

let make = UnifiedAddDisplayOnlyMember;

exports.AddDisplayMemberMutation = AddDisplayMemberMutation;
exports.useAddDisplayMember = useAddDisplayMember;
exports.Form = Form;
exports.Query = Query;
exports.Page = Page;
exports.make = make;
/* commitMutation Not a pure module */
